import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {AuthService} from '../services/auth.service';
import {TokenStorageService} from '../services/storage/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ApiGuard implements CanActivate {

  constructor(
    private tokenStorageService: TokenStorageService,
    private router: Router,
    private auth: AuthService,
    private keycloakService: KeycloakService,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {

    const isLoggedIn =
      this.keycloakService.isLoggedIn() ||
      !!this.tokenStorageService.getToken();

    if (!isLoggedIn) {
      // Returning a UrlTree (instead of navigate + false) lets the router
      // handle the redirect atomically during the same navigation
      return this.router.parseUrl('/');
    }

    return true;
  }

}
